function language(state = [], action){
    if(action.type === "LANGUAGE_EN"){
        return 'en'
    }
    if(action.type === "LANGUAGE_JA"){
        return 'ja'
    }
    if(action.type === "PRIVACY"){
        return 'privacy'
    }
    if(action.type === "PRIVACY_EN"){
        return 'privacy_en'
    }
    if(action.type === "PRIVACY_AL"){
        return 'privacy_al'
    }
    if(action.type === "PRIVACY_AL_EN"){
        return 'privacy_al_en'
    }
    if (typeof state !== 'undefined') {
        return state
    }
}

export default language;


// WEBPACK FOOTER //
// ./src/reducers/language.js